import type { Component } from 'vue'
import {
  Bell,
  Briefcase,
  ChatDotRound,
  CircleCheck,
  Coin,
  Collection,
  DataBoard,
  Document,
  DocumentChecked,
  Edit,
  Files,
  FolderOpened,
  Grid,
  HomeFilled,
  InfoFilled,
  List,
  Location,
  Lock,
  Message,
  Monitor,
  Money,
  Notification,
  OfficeBuilding,
  Picture,
  Platform,
  PriceTag,
  Promotion,
  Refresh,
  Search,
  Setting,
  Tickets,
  Timer,
  Upload,
  User,
  UserFilled,
  VideoPlay,
  View,
  WarnTriangleFilled
} from '@element-plus/icons-vue'

const MENU_ICON_ALIASES: Record<string, Component> = {
  dollar: Money,
  apartment: OfficeBuilding,
  'appstore-fill': Grid,
  bell: Bell,
  'carryout-fill': CircleCheck,
  'check-square': CircleCheck,
  container: Collection,
  dashboard: DataBoard,
  database: Coin,
  desktop: Monitor,
  detail: Tickets,
  'detail-fill': Tickets,
  'edit-square': Edit,
  eye: View,
  'file-exception': WarnTriangleFilled,
  'file-word': Document,
  filedone: DocumentChecked,
  fileprotect: Lock,
  filesearch: Search,
  'font-colors': Edit,
  'golden-fill': Money,
  home: HomeFilled,
  'info-circle': InfoFilled,
  location: Location,
  mail: Message,
  message: ChatDotRound,
  'message-fill': ChatDotRound,
  notification: Notification,
  'pic-left': Picture,
  'play-square': VideoPlay,
  reloadtime: Timer,
  rocket: Promotion,
  safetycertificate: Lock,
  setting: Setting,
  solution: Briefcase,
  sync: Refresh,
  table: Grid,
  tag: PriceTag,
  tags: PriceTag,
  team: UserFilled,
  addteam: UserFilled,
  unorderedlist: List,
  upload: Upload,
  user: User,
  'wechat-fill': ChatDotRound,
  windows: Platform,
  files: Files
}

const normalizeIconName = (value: string): string => {
  return value.trim().replace(/^icon-/i, '').toLowerCase()
}

/**
 * 兼容 baseproject/tools-server 保存的 icon-* 名称。
 * 未识别的历史值继续显示稳定的父级/页面回退图标。
 */
export const resolveAdminMenuIcon = (
  value: string | boolean | null | undefined,
  isGroup: boolean
): Component | null => {
  if (value === false) return null
  if (typeof value === 'string') {
    const resolved = MENU_ICON_ALIASES[normalizeIconName(value)]
    if (resolved) return resolved
  }
  return isGroup ? FolderOpened : Document
}
